import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property, queryAssignedElements, } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Submenu element, used to wrap submenu-item elements
 *
 * @slot - Unnamed slot (default)
 *
 */
let SDBNavSubMenu = class SDBNavSubMenu extends LitElement {
    constructor() {
        super(...arguments);
        this.selected = '';
        this.attrForSelected = '';
    }
    render() {
        return html `<slot @slotchange=${this.updateActiveMenuItem}></slot>`;
    }
    updated(changedProperties) {
        if (changedProperties.has('selected')) {
            this.updateActiveMenuItem();
        }
    }
    updateActiveMenuItem() {
        for (const node of this._defaultSlotNodes) {
            const attrValue = node.getAttribute(this.attrForSelected);
            if (attrValue === this.selected) {
                node.setAttribute('active', '');
            }
            else {
                node.removeAttribute('active');
            }
        }
    }
};
SDBNavSubMenu.styles = [
    elements,
    css `
  :host {
    display: flex;
    width:fit-content;
    max-width:1400px;
    grid-gap:15px;
    justify-items:start;
    flex-flow:row wrap;
  }

    @media only screen and (max-width: 767px) {
      /* For mobile phones: */
      :host{
        grid-auto-columns:1fr;
        grid-auto-flow:row;
        width:100%;
      }

  `,
];
__decorate([
    queryAssignedElements({ flatten: true, selector: 'sdb-nav-submenu-item' })
], SDBNavSubMenu.prototype, "_defaultSlotNodes", void 0);
__decorate([
    property({ type: String })
], SDBNavSubMenu.prototype, "selected", void 0);
__decorate([
    property({ type: String })
], SDBNavSubMenu.prototype, "attrForSelected", void 0);
SDBNavSubMenu = __decorate([
    customElement('sdb-nav-submenu')
], SDBNavSubMenu);
export { SDBNavSubMenu };
//# sourceMappingURL=sdb-nav-submenu.js.map